<template>
  <div >
  <!-- <div style="position: fixed; top: 0; left: 0; background-color: #ffffff; color: #000000; z-index: 100; width: 100vw; height: 2rem;">
    {{alertText}}
  </div> -->
    <div id="loading-container">
      <div v-if="isLoading">
        <!-- <img src="../../assets/img/loading-2.gif" alt="loading"/> -->
        <div class='loaddiv'></div>
      </div>
      <div v-else class="notdata" id="loading-text" style="font-size: 0.8em;">{{loadText}}</div>
    </div>

    <div v-if="isNoMoreData" class="notdata" style="text-align: center;">暂时没有更多啦!</div>
  </div>
</template>

<script>
import scrollService from '../../services/scrollService'

export default {
  name: 'loading',
  props: {
    isScroll: {
      type: Boolean,
      default: true
    },
    scrollDiv: String,
    isLoading: Boolean,
    isNoMoreData: Boolean
  },
  data () {
    return {
      touchStartY: 0,
      dy: 0,
      loadText: '继续上拉加载更多',
      alertText: ''
    }
  },
  methods: {
    scrollFunction () {
      // let obj = document.getElementById(this.scrollDiv);
      // this.alertText = `${obj.scrollTop} (${Mathdd.ceil(obj.scrollTop)}) + ${obj.offsetHeight} = ${Math.ceil(obj.scrollTop) + obj.offsetHeight} >= ${obj.scrollHeight}`;
      if (scrollService.isReachBottom(this.scrollDiv) && this.isScroll) {
        // alert('scrollFunction '+this.isNoMoreData)
        if (!this.isNoMoreData) {
          window.addEventListener('touchstart', this.startLoadMore)
          window.addEventListener('touchmove', this.showLoadMore)
          window.addEventListener('touchend', this.endLoadMore)
          scrollService.removeScrollListener(this.scrollDiv, this.scrollFunction)
          this.alertText = 'scroll function removed'
        }
      }
    },
    startLoadMore (event) {
      this.touchStartY = event.touches[0].clientY
      this.alertText = 'start touch function'
    },
    showLoadMore (event) {
      if (this.isNoMoreData) return
      const y = event.touches[0].clientY
      let dy = y - this.touchStartY
      const container = document.getElementById('loading-container')
      const text = document.getElementById('loading-text')
      this.dy = dy
      dy = dy < 0 ? Math.abs(dy) : 0
      if (dy > 200) {
        this.loadText = '松开加载更多'
      } else {
        this.loadText = '继续上拉加载更多'
      }
      text.style.transform = `scale(${(dy > 200 ? 200 : dy) / 200})`
      container.style.height = `${dy > 200 ? 50 : 50 * dy / 200}px`
      if (dy !== 0) {
        container.scrollIntoView()
      }
    },
    endLoadMore (event) {
      const obj = document.getElementById('loading-text')
      obj.style.transform = 'scale(0)'
      if (this.dy <= -200 && !this.isNoMoreData) {
        this.$emit('get-books')
      } else {
        const container = document.getElementById('loading-container')
        const text = document.getElementById('loading-text')
        container.style.height = '0px'
        text.style.transform = 'scale(0)'
        setTimeout(() => {
          this.scrollFunction()
        }, 0)
      }
      this.touchStartY = -200
      this.dy = 0
      window.removeEventListener('touchstart', this.startLoadMore)
      window.removeEventListener('touchmove', this.showLoadMore)
      window.removeEventListener('touchend', this.endLoadMore)
      scrollService.addScrollListener(this.scrollDiv, this.scrollFunction)
      this.alertText = 'scroll function added'
    }
  },
  mounted () {
    this.isScroll && scrollService.addScrollListener(this.scrollDiv, this.scrollFunction)
  },
  beforeDestroy () {
    this.isScroll && scrollService.removeScrollListener(this.scrollDiv, this.scrollFunction)
  },
  watch: {
    isLoading (data) {
      if (!data) {
        const container = document.getElementById('loading-container')
        container.style.height = '0'
      }
    }
  }
}
</script>

<style scoped>
  #loading-container {
    height: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  #loading-container #loading-text {
    transform: scale(0);
  }
</style>
